<template>
    <div>
        <rkm-data-table
            :fields="fields"
            :repository="repositories.procedimentoRaas"
            ref="DataTable"
            sort-by="unidadeNomeFantasia"
            search-by="unidadeNomeFantasia"
        >
            <template v-slot:cell(cidPrincipal)="{ item }">
                <span
                    :title="item.cidPrincipalNome"
                    v-rkm-tooltip.hover
                >
                    {{ item.cidPrincipalCodigo ? formatCid(item.cidPrincipalCodigo) : null }}
                </span>
            </template>

            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    :title="!item.exportado ? 'Editar' : 'Visualizar'"
                    @click="$refs.Modal.open(item)"
                    color="primary"
                    small
                    authorize="update-raas-procedimento"
                >
                    <rkm-icon :icon="!item.exportado ? 'pen' : 'eye'" />
                </rkm-button>

                <rkm-button
                    :disabled="!!item.exportado"
                    @click="handleDestroy(item.id)"
                    color="danger"
                    small
                    title="Excluir"
                    authorize="destroy-raas-procedimento"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-data-table>

        <Modal
            @close="$refs.DataTable.refresh()"
            ref="Modal"
        />
    </div>
</template>

<script>
// Components.
import Modal from './components/cadastro/Modal.vue'

// Mixins.
import { repository, formats } from '@/mixins'

export default {
    components: { Modal },
    created() {

        this.repositories = {
            procedimentoRaas: this.getConectaSusRepository('raas.procedimento'),
        }
    },
    data() {

        return {
            fields: [
                { key: 'unidadeNomeFantasia', name: 'unidade.nomeFantasia', label: 'Unidade', searchable: true, sortable: true },
                { key: 'competenciaValor', name: 'competencia.valor', label: 'Competência', searchable: true, sortable: true },
                {
                    key: 'dataAdmissao',
                    name: 'atendimento.dataAdmissao',
                    label: 'Data de admissão',
                    formatter: v => this.formatDate(v),
                    searchable: true,
                    sortable: true
                },
                { key: 'origemPacienteNome', name: 'origemPaciente.nome', label: 'Origem do paciente', searchable: true, sortable: true },
                { key: 'pacienteNome', name: 'cidadao.nome', label: 'Paciente', searchable: true, sortable: true },
                { key: 'cidPrincipal', name: 'cidPrincipal', label: 'CID principal', searchable: true, sortable: true },
                { key: 'destinoPacienteNome', name: 'destinoPaciente.nome', label: 'Destino do paciente', searchable: true, sortable: true },
                { key: 'numeroAutorizacao', name: 'atendimento.numeroAutorizacao', label: 'Número de autorização', searchable: true, sortable: true },
                { key: 'actions', label: 'Ações', class: 'col-min text-center' },
            ],
        }
    },
    methods: {
        refresh() {

            this.$refs.DataTable.refresh()
        },
        handleDestroy(id) {

            this.showDeleteConfirmation(
                'Deseja realmente excluir o atendimento e seus procedimentos?',
                () => this.repositories.procedimentoRaas.destroy(id).then(() => this.$refs.DataTable.refresh())
            )
        },
    },
    mixins: [repository, formats],
}
</script>